import { v } from 'convex/values'

import { improveAreasLine } from './improveAreas'

// What the user came for, picked on onboarding's first step. Unset = 'both'.
export const FOCUSES = ['habits', 'goals', 'both'] as const
export type Focus = (typeof FOCUSES)[number]
export const focusValidator = v.union(v.literal('habits'), v.literal('goals'), v.literal('both'))

export const HABITS_FOCUS_LINE =
  "Here for habits: they came to build daily habits, not to plan goals. Focus on their habits, streaks and today's check-ins; don't push them to create a goal unless they bring one up."

export function focusLine(focus: string | undefined): string | null {
  return focus === 'habits' ? HABITS_FOCUS_LINE : null
}

export type CoachProfile = {
  name?: string
  lifestyle?: string
  lifeAreas?: string[]
  improveSubAreas?: string[]
  aspiration?: string
  timeAvailable?: string
  focus?: string
}

// The coach chat's "About this user" lines.
export function coachProfileLines(up: CoachProfile): string[] {
  const lines: string[] = []
  if (up.name) lines.push(`Name: ${up.name}`)
  if (up.lifestyle) lines.push(`Situation: ${up.lifestyle}`)
  if (up.improveSubAreas?.length)
    lines.push(improveAreasLine(up.lifeAreas ?? [], up.improveSubAreas))
  else if (up.lifeAreas?.length) lines.push(`Focus areas: ${up.lifeAreas.join(', ')}`)
  if (up.timeAvailable) lines.push(`Available daily: ${up.timeAvailable}`)
  if (up.aspiration) lines.push(`Their aspiration: "${up.aspiration}"`)
  const f = focusLine(up.focus)
  if (f) lines.push(f)
  return lines
}
